import { ReactElement } from "react"
import pin from '../../assets/pin.svg'
import whatsapp from '../../assets/whatsapp.svg'
import { FooterProps } from "./footer-props"
import * as S from './footer-style'

export function FooterAddress ({ address, contact }: FooterProps): ReactElement {
  return <S.Container>
    <S.CardWrapper>
      <S.Card>
        <img src={pin} alt="Pin" />
        <S.Title>{address.title}</S.Title>
        <S.Content>{address.content}</S.Content>
      </S.Card>
      <S.Card>
        <img src={whatsapp} alt="WhatsApp" />
        <S.Title>{contact.title}</S.Title>
        <S.Content>{contact.content}</S.Content>
      </S.Card>
    </S.CardWrapper>
    <S.PrivacyPolicy>
      <p><a href="https://www.cartaodetodos.com.br/politica-de-privacidade/" target="_blank" rel="noreferrer">Politica de privacidade</a></p>
      <p>* Cartão de desconto não é plano de saúde, não garante e não se responsabiliza pelos serviços oferecidos e pelo pagamento das despesas, nem assegura desconto em todos os serviços obrigatoriamente garantidos por plano de saúde. Tudo o que o cliente usar ou comprar será por ele pago ao prestador, assegurando-se apenas os preços e descontos que constam na relação de empresas e serviços conveniados disponibilizados no site www.cartaodetodos.com.br. O atendimento será em até 15 dias, mediante disponibilidade na clínica. Consulte a clínica parceira para as especialidades disponíveis e condições para marcar as consultas.</p>
      <p>TODOS Empreendimentos LTDA 04.644.515/0001-85 © 2024.</p>
    </S.PrivacyPolicy>
  </S.Container>
}